/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OnePassAndRecordingsUserSettings } from 'client-code/user-settings';

import {
    SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
    SET_ONEPASS_AND_RECORDING_ERROR,
    SET_ONEPASS_AND_RECORDING_OPTIONS,
    SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
} from './onepassandrecordings.types';

export const setSelectedIndexOnePassAndRecordingOptionsAction = (index: number) => ({
    type: SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
    payload: {
        selectedIndex: index,
        isFocused: true,
    },
});

export const setGhostIndexOnePassAndRecordingOptionsAction = (ghostMode: boolean) => ({
    type: SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
    payload: {
        ghostMode,
    },
});

export const setOnePassAndRecordingOptionsAction = (options: OnePassAndRecordingsUserSettings) => ({
    type: SET_ONEPASS_AND_RECORDING_OPTIONS,
    payload: {
        options,
    },
});

export const setOnePassAndRecordingErrorAction = (hasError: boolean) => ({
    type: SET_ONEPASS_AND_RECORDING_ERROR,
    payload: {
        hasError,
    },
});
